// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unused-vars
const noop = (...args: any[]): any => null;

export { noop };
